"use client";

import { useMemo, useState } from "react";
import Link from "next/link";

import { artigos } from "../../artigos/_data/artigos";

export default function ArtigosLista() {
    const [busca, setBusca] = useState("");

    const artigosFiltrados = useMemo(() => {
        const termo = busca
            .trim()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();

        return [...artigos]
            .filter((artigo) => {
                const conteudoTexto = artigo.conteudo.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ");

                const textoArtigo = [
                    artigo.titulo,
                    artigo.descricao,
                    artigo.categoria,
                    conteudoTexto
                ]
                    .join(" ")
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toLowerCase();

                return textoArtigo.includes(termo);
            })
            .sort((a, b) => new Date(b.data).getTime() - new Date(a.data).getTime());
    }, [busca]);

    return (
        <div>
            <div className="max-w-2xl mx-auto mb-10">
                <label htmlFor="buscar-artigos" className="block text-sm font-semibold mb-2">
                    Pesquisar artigos
                </label>

                <div className="relative">
                    <input
                        id="buscar-artigos"
                        type="search"
                        value={busca}
                        onChange={(e) => setBusca(e.target.value)}
                        placeholder="Busque por título, técnica ou assunto..."
                        className="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 pr-12 text-black shadow-sm outline-none transition focus:border-[#038291] focus:ring-2 focus:ring-[#038291]/20"
                    />

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="absolute right-4 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-500 pointer-events-none"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                        aria-hidden="true"
                    >
                        <circle cx="11" cy="11" r="7" />
                        <path strokeLinecap="round" d="m16 16 4 4" />
                    </svg>
                </div>

                <p className="text-sm text-gray-500 mt-2">
                    {artigosFiltrados.length}{" "}
                    {artigosFiltrados.length === 1 ? "artigo encontrado" : "artigos encontrados"}
                </p>
            </div>

            {artigosFiltrados.length > 0 ? (
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {artigosFiltrados.map((artigo) => (
                        <article
                            key={artigo.slug}
                            className="group rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition"
                        >
                            <Link href={`/artigos/${artigo.slug}`} className="block h-full">
                                <div className="p-6 flex flex-col h-full">
                                    <span className="text-sm text-gray-500">
                                        {artigo.categoria}
                                    </span>

                                    <div className="flex-grow">
                                        <h2 className="text-2xl font-bold mt-2 mb-4 line-clamp-3">
                                            {artigo.titulo}
                                        </h2>

                                        <p className="text-gray-600 mb-6 line-clamp-6">
                                            {artigo.descricao}
                                        </p>
                                    </div>

                                    <p className="font-semibold group-hover:text-[#038291] transition">
                                        Ler artigo
                                    </p>
                                </div>
                            </Link>
                        </article>
                    ))}
                </div>
            ) : (
                <div className="text-center py-12">
                    <h2 className="text-xl font-bold mb-2">Nenhum artigo encontrado</h2>

                    <p className="text-gray-600 mb-6">
                        Tente pesquisar por outro título, técnica ou assunto.
                    </p>

                    <button
                        type="button"
                        onClick={() => setBusca("")}
                        className="font-semibold text-[#038291] hover:underline"
                    >
                        Limpar pesquisa
                    </button>
                </div>
            )}
        </div>
    );
}
